import FormData from "./SuitabilityFormData";

/**
 * Maps data from `calFormData` and `quoteFormData` to a new form data object.
 *
 * @param {CalculatorForm} calFormData - The data from the suitability calculator form.
 * @param {Object} quoteFormData - The data from the quote form.
 * @returns {SuitabilityFormData} - The mapped form data object.
 */
export const mapDataToSuitabilityData = (calFormData, quoteFormData, suitabilityMatrix) => {
  return {
    ...FormData,
    ...quoteFormData,
    cdob: calFormData.user_dob,
    cage: calFormData.age,
    name: calFormData.user_name,
    AnnualIncome: calFormData.yr_income,
    age: calFormData.age,
    dob: calFormData.user_dob,
    EmailId: calFormData.emailid,
    MobileNo: calFormData.mobileno,
    gender: calFormData.gender,
    trai: calFormData.trai_flag,
    LDUID: calFormData.LDUID,
    useTobacco: suitabilityMatrix?.useTobacco,
    insurancePortfolioHeld: suitabilityMatrix?.insurancePortfolioHeld,
    lifeStage: suitabilityMatrix?.lifeStage,
    FFGoal: suitabilityMatrix?.financialAndFamilyGoals,
    goalHorizon: suitabilityMatrix?.goalHorizon,
    riskProfile: suitabilityMatrix?.riskProfile,
    paymentPref: suitabilityMatrix?.paymentPreference,
  };
};
